export default "__VITE_ASSET__VaZiYNK1__"